export default __webpack_public_path__ + "static/media/7_Intro.0459462c.mp4";